import { createClient } from "tinacms/dist/client";
import { queries } from "./types";
export const client = createClient({ cacheDir: "/vercel/path0/tina/__generated__/.cache/1744281295865", url: "https://content.tinajs.io/1.5/content/f63b45ad-399e-462a-b3a8-57d9cabde043/github/main", token: "13978942ea21f56e3a81f12a1ee5322f64a37549", queries });
export default client;
